/**
 * Only put public interfaces in here
 */
import { BuildabilityStatusV2 } from '../v2';
export var BuildabilityStatusV1 = BuildabilityStatusV2;
